import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import PatientRecieveFee from "./PatientRecieveFee"

const PatientRecieveFeeContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <PatientRecieveFee />
      </div>
    </div>
  )
}

export default PatientRecieveFeeContainer